import React from 'react';
import { Button } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

const CodeResetButton = ({ theme, codeReset }) => {
  return (
    <Button
      onClick={codeReset}
      title="Use this button to restore the text editor to its default boilerplate code."
      style={{
        margin: '0 0 0 8px',
        border: 'none',
        textDecoration: 'underline',
        background: 'none',
        color: theme === 'vs-dark' ? '#fff' : '#1890FF',
      }}
    >
      <SyncOutlined /> Reset
    </Button>
  );
};

export default CodeResetButton;
